import { useEffect } from 'react'

import { useAdobeTargetContext } from '@cox/core-ui8/dist/AdobeTargetContext'

import RuleResultsRenderer from '../../RuleBuilder/RuleResultsRenderer'

let compId = 0

const ConditionalDefaultBlock = ({
  defaultConditional,
  ruleId,
  ruleExpression,
  index,
  isInEditor,
  componentTypeRenderer,
  compName
}: {
  defaultConditional: any
  ruleId: string
  ruleExpression: string
  index: number
  isInEditor: boolean
  componentTypeRenderer: any
  compName: string
}) => {
  const { register, unregister } = useAdobeTargetContext()
  const dynamicRuleId = `${compName}-${compId++}`

  useEffect(() => {
    /**Rule Builder Conditional Default Block Component registers with rule Id
     * Rule Results Renderer Component unregisters with rule Id */
    if (defaultConditional?.defaultblock) {
      register(ruleId || dynamicRuleId)
      return () => {
        unregister(ruleId || dynamicRuleId)
      }
    }
  }, [])

  if (defaultConditional?.defaultblock) {
    return (
      <div id='rule-results' className='rule-results' data-testid={ruleId || dynamicRuleId} key={index}>
        <RuleResultsRenderer
          key={index}
          ruleId={ruleId || dynamicRuleId}
          results={defaultConditional.resultsTrue}
          ruleExpression={ruleExpression}
          index={index}
          isInEditor={isInEditor}
          componentTypeRenderer={componentTypeRenderer}
        />
      </div>
    )
  }
  return <></>
}
export default ConditionalDefaultBlock
